"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _wrapRegExp(re, groups) { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _RegExp = _wrapNativeSuper(RegExp); var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = _RegExp.call(this, re, flags); _groups.set(_this, groups || _groups.get(re)); return _this; } _inherits(BabelRegExp, _RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = []; args.push.apply(args, arguments); if (_typeof(args[args.length - 1]) !== "object") { args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var nameMapper = function nameMapper(isJanssen, isCustomMetadata, val) {
  var authors = isCustomMetadata ? (val + "").split(",") : val;
  return authors.map(function (author) {
    var isJapanese = author.match(/[\u3000-\u303f]+/g) || author.match(/[\u3040-\u309f]+/g) || author.match(/[\u30a0-\u30ff]+/g) || author.match(/[\uff00-\uffef]+/g) || author.match(/[\u4e00-\u9faf]+/g);
    if (author && author.endsWith("~")) return {
      literal: author.slice(0, -1)
    };
    if (!isJanssen && isJapanese && !author.includes(' ')) return {
      literal: author
    };
    var delimiter = isJanssen ? "," : " ";
    var nameTokens = author.split(delimiter).map(function (token) {
      return token === null || token === void 0 ? void 0 : token.trim();
    });
    var family = '';
    var given = '';
    if (!(nameTokens === null || nameTokens === void 0 ? void 0 : nameTokens.length)) return {
      family: family,
      given: given
    };
    family = isJapanese || isJanssen ? nameTokens.shift() : nameTokens.pop();
    if (!(nameTokens === null || nameTokens === void 0 ? void 0 : nameTokens.length)) return {
      family: family,
      given: given
    };
    given = nameTokens.join(" ");
    return {
      family: family,
      given: given
    };
  });
};

var dateMapper = function dateMapper(isJannsen, isCustomMetadata, val) {
  if (!val) return;

  var dateWrapper = function dateWrapper(dates) {
    return {
      "date-parts": [dates]
    };
  };

  if (/^\d{1,4}$/.test(val) && val > 0) return dateWrapper([val]);

  var checkValidParts = function checkValidParts(groups, parts) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var part = _step.value;
        if (groups[part] == null || groups[part] <= 0) return false;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  };

  var dateParts = _wrapRegExp(/^([0-9]{1,4})\x2D([0-9]{1,2})$/, {
    year: 1,
    month: 2
  }).exec(val);

  var hasYearMonth = dateParts && dateParts.groups && checkValidParts(dateParts.groups, ['year', 'month']);
  if (hasYearMonth) return dateWrapper([dateParts.groups.year, dateParts.groups.month]);
  dateParts = _wrapRegExp(/^([0-9]{1,4})\x2D([0-9]{1,2})\x2D([0-9]{1,2})$/, {
    year: 1,
    month: 2,
    day: 3
  }).exec(val);
  var hasYearMonthDate = dateParts && dateParts.groups && checkValidParts(dateParts.groups, ['year', 'month', 'day']);
  if (hasYearMonthDate) return dateWrapper([dateParts.groups.year, dateParts.groups.month, dateParts.groups.day]);
};

var tagMapper = function tagMapper(isJannsen, isCustomMetadata, val) {
  return val.join(",");
};

var complexFields = {
  nameFields: ["author", "assignee", "attorney_agent", "container-author", "cast_member", "composer", "cosponsor", "country", "guest", "producer", "recipient", "reviewed-author", "editor", "scriptwriter", "collection-editor", "translator", "series-editor"],
  dateFields: ["accessed", "issued", "filing-date"],
  tagFields: ["tags"]
};
var complexFieldsMap = Object.entries(complexFields).reduce(function (map, entry) {
  var _entry = _slicedToArray(entry, 2),
      complexType = _entry[0],
      fields = _entry[1];

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = fields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var field = _step2.value;
      map[field] = complexType;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return map;
}, {});
var mappers = {
  "nameFields": nameMapper,
  "dateFields": dateMapper,
  "tagFields": tagMapper
};
module.exports = {
  complexFieldsMap: complexFieldsMap,
  mappers: mappers,
  dateMapper: dateMapper
};